import React, { useEffect, useState } from 'react';
import { t } from '../../i18n';
import { useParams } from 'react-router-dom';
import { realtyApi } from './realtyApi';
import { EMICalculator, AgentRatingWidget } from './RealtyExtras';
import ReviewBox, { VerifiedBadge } from '../ReviewBox';

export default function RealtyPropertyDetail() {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '', phone: '', message: '' });
  const [sent, setSent] = useState(false);

  useEffect(() => {
    realtyApi.getProperty(id).then(setProperty).catch((e) => setError(e.message));
  }, [id]);

  async function handleInquiry(e) {
    e.preventDefault();
    try {
      await realtyApi.sendInquiry({ property: id, ...form });
      setSent(true);
    } catch (e) {
      setError(e.message);
    }
  }

  if (error) return <div className="realty-scope container section"><div className="error-box">{error}</div></div>;
  if (!property) return <div className="realty-scope container section muted">{t('loading')}</div>;

  const p = property;

  return (
    <div className="realty-scope">
      <div className="detail-hero">
        <div className="container">
          <span className={`yard-tag ${p.purpose === 'rent' ? 'rent' : ''}`} style={{ position: 'static', display: 'inline-block' }}>
            For {p.purpose === 'rent' ? 'Rent' : 'Sale'}
          </span>
          <h1 className="display" style={{ color: '#fff', marginTop: 10, fontSize: 26 }}>{p.title}</h1>
          <p style={{ color: '#D8ECE2', marginTop: 6 }}>{p.area}, {p.city}</p>
        </div>
      </div>

      <div className="detail-grid">
        <div>
          <div className="gallery-main">
            {p.images && p.images.length ? (
              <img src={p.images[0].image} alt={p.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 10 }} />
            ) : 'No photos uploaded yet'}
          </div>

          <div className="spec-list">
            <div className="spec-item"><b>{p.area_size} {p.area_unit}</b>{t('area_label')}</div>
            <div className="spec-item"><b>{p.bedrooms ?? '—'}</b>{t('bedrooms')}</div>
            <div className="spec-item"><b>{p.bathrooms ?? '—'}</b>{t('bathrooms')}</div>
            <div className="spec-item"><b>{p.property_type}</b>{t('type_label')}</div>
          </div>

          <div className="side-card" style={{ marginTop: 20 }}>
            <h3 style={{ fontSize: 17, marginBottom: 8 }}>{t('description')}</h3>
            <p className="muted" style={{ lineHeight: 1.6 }}>{p.description}</p>
          </div>

          {p.purpose === 'sale' && (
            <div style={{ marginTop: 20 }}>
              <EMICalculator propertyPrice={Number(p.price)} />
            </div>
          )}
          <div style={{ marginTop: 20 }}>
            <ReviewBox
              module="realty"
              objectId={p.id}
              objectTitle={p.title}
              token={localStorage.getItem('xr_token')}
              loggedIn={!!localStorage.getItem('xr_token')}
              isAdmin={!!(p.agent && p.agent.user && p.agent.user.username === 'khalidxpert')}
            />
          </div>
        </div>

        <div>
          <div className="side-card">
            <div style={{ marginBottom: 8 }}><VerifiedBadge module="realty" objectId={p.id} /></div>
            <div className="card-price" style={{ fontSize: 24 }}>
              Rs {Number(p.price).toLocaleString()}{p.purpose === 'rent' ? ' / month' : ''}
            </div>
            {p.price_pi && <div className="muted" style={{ marginTop: 4 }}>≈ {Number(p.price_pi).toLocaleString()} Pi</div>}
            <div className="muted" style={{ marginTop: 10 }}>Listed by {p.agent?.user?.username}</div>
          </div>

          <AgentRatingWidget agent={p.agent} />

          <div className="side-card">
            <h3 style={{ fontSize: 16, marginBottom: 12 }}>{t('contact_owner')}</h3>
            {sent ? (
              <div className="success-box">{t('inquiry_sent')}</div>
            ) : (
              <form onSubmit={handleInquiry}>
                <div className="field">
                  <label>{t('your_name')}</label>
                  <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                </div>
                <div className="field">
                  <label>{t('phone_number')}</label>
                  <input required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                </div>
                <div className="field">
                  <label>Message (optional)</label>
                  <textarea rows="3" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
                </div>
                <button className="btn btn-primary" style={{ width: '100%' }}>{t('send_inquiry')}</button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
